import Model from "./base/model";

class notfisFile extends Model{
    resourceName() {
        return "notfis_files";
    }

    fields() {
        return {
          name: "",
          path: "",
          version: "",
        }
    }
}

export default new notfisFile();
